import { NIKE_URL } from "@/constants/url";
import { Lang } from "@/data/translation";
import { z } from "zod";

type PortfolioReturnsParams = {
  portfolioId: string;
  lang: Lang;
};

const returnDataSchema = z.object({
  date: z.string(),
  benchmarkReturn: z.number().nullish(),
  portfolioReturn: z.number().nullish(),
});

const portfolioReturnsDataSchema = z.object({
  cumulativeReturns: z.array(returnDataSchema),
  yearlyReturns: z.array(returnDataSchema),
});

export const PortfolioReturnsResponseSchema = z.object({
  data: portfolioReturnsDataSchema,
  message: z.string(),
});

export type PortfolioReturns = z.infer<
  typeof PortfolioReturnsResponseSchema
>["data"];

export type PortfolioReturnsPeriod = keyof PortfolioReturns;

export const getPortfolioReturns = async ({
  portfolioId,
  lang,
}: PortfolioReturnsParams): Promise<PortfolioReturns> => {
  if (!portfolioId || !lang) throw new Error("missing required params");
  const endpoint = `/customized-portfolio/portfolio-returns/${portfolioId}`;
  const res = await fetch(`${NIKE_URL}${endpoint}`, {
    method: "GET",
    headers: { "Accept-Language": lang },
  });
  if (!res.ok) throw new Error(`API failed (${endpoint})`);
  return PortfolioReturnsResponseSchema.parse(await res.json()).data;
};
